export default {

    index (params) {
        return window.axios.get('/api/employee-expenses', {params});
    },

    save (data) {
        if (data.id) {
            return window.axios.put(`/api/employee-expenses/${data.id}`, data);
        }
        return window.axios.post('/api/employee-expenses', data);
    },

    get (id) {
        return window.axios.get(`/api/employee-expenses/${id}`);
    },

    delete (id) {
        return window.axios.delete(`/api/employee-expenses/${id}`);
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/EmployeeExpensesService.js